import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput, ReduxNumberInput } from 'components/FormElements'
// types
import { Forms } from 'constants/forms'
import { FieldType, IField } from 'types/graphql'

interface Props {
  field: IField
}

const TextFieldForm: React.FC<InjectedFormProps<{ value: string }, Props> & Props> = ({ field }) => {
  const isText = field?.fieldType === FieldType.Text

  return (
    <>
      {isText ? (
        <ReduxInput multiline name='value' autoFocus />
      ) : (
        <ReduxNumberInput field={field} name='value' autoFocus />
      )}
    </>
  )
}

export default reduxForm<any, Props>({
  form: Forms.TEXT_FIELD_FORM
})(TextFieldForm)
